var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('div',[(_vm.authorizationMessageHtml)?_c('div',{staticClass:"authorization-msg mb-4",domProps:{"innerHTML":_vm._s(_vm.authorizationMessageHtml)}}):_vm._e(),_c('div',{staticClass:"status-msg font-italic"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }